import { Link } from 'react-router-dom';

export default function HowWeRate() {
  const criteria = [
    {
      icon: 'ri-gift-fill',
      title: 'Bonuses & Promotions',
      description: 'We evaluate welcome bonuses, ongoing promotions, and loyalty programs. We check wagering requirements, terms and conditions, and overall value to ensure you get fair and achievable bonus offers.'
    },
    {
      icon: 'ri-gamepad-fill',
      title: 'Game Selection',
      description: 'Our experts assess the variety and quality of games available, including slots, table games, and live dealer options. We consider game providers, software quality, and the overall gaming experience.'
    },
    {
      icon: 'ri-bank-card-fill',
      title: 'Payment Methods',
      description: 'We test deposit and withdrawal options, processing times, and transaction fees. We verify that casinos offer secure, convenient payment methods including credit cards, e-wallets, and cryptocurrencies.'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Customer Support',
      description: 'We evaluate support availability, response times, and helpfulness. Our team tests live chat, email, and phone support to ensure you can get assistance whenever you need it.'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Licensing & Security',
      description: 'We verify that casinos hold valid licenses from reputable authorities. We check SSL encryption, data protection policies, and responsible gambling measures to ensure your safety and security.'
    },
    {
      icon: 'ri-smartphone-fill',
      title: 'Mobile Experience',
      description: 'We test mobile compatibility, app functionality, and responsive design. We ensure that casinos provide a seamless gaming experience across all devices including smartphones and tablets.'
    }
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center md:mb-12 mb-8">
          <h2 className="md:text-3xl text-2xl font-bold text-gray-900 mb-3">How We Rate Online Casinos</h2>
          <p className="text-md text-gray-600 max-w-3xl mx-auto">
            Our expert team uses a comprehensive evaluation process to review every casino. We test each platform thoroughly to provide you with accurate, unbiased ratings you can trust.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {criteria.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200 hover:border-gray-300 transition-colors">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-2xl text-green-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/methodology" className="text-green-600 font-semibold hover:text-green-700 transition-colors inline-flex items-center">
            Read Our Full Methodology
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}